import { render, staticRenderFns } from "./ColumnConfig.vue?vue&type=template&id=f838a680&scoped=true"
import script from "./ColumnConfig.vue?vue&type=script&lang=js"
export * from "./ColumnConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f838a680",
  null
  
)

export default component.exports